import { mergeStyles } from "@fluentui/merge-styles";
import { MessageBar, MessageBarBody } from "@fluentui/react-components";
import React from "react";

const wrapperClass = mergeStyles({
  height: "100vh",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

const ErrorBoundaryFallback = () => {
  return (
    <div className={wrapperClass}>
      <MessageBar intent="warning">
        <MessageBarBody>
          <div>Something went wrong...</div>
          <div>Please reload the Add-in</div>
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};

export default ErrorBoundaryFallback;
